"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateServicePayloadToFormDataHandler = updateServicePayloadToFormDataHandler;
function updateServicePayloadToFormDataHandler(data) {
    const services = Object.entries(data.form.services || []).map(([service, status]) => ({
        service: service,
        status: status,
    }));
    return {
        services,
        notes: data.form.notes || "",
    };
}
